import { useTranslations } from "next-intl";
import { FILES } from "i18n/constants";
import { Button } from "@hubble/web";
import type { PricePageReferralCardDataType } from "types/prices";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import { buildContentfulImageUrl } from "components/common/utils/contentful-utils";
import { Body } from "app/_components/components/Text/Body";
import { Heading } from "app/_components/components/Text/Heading";

interface ReferralCardProps {
  referralCardEntry?: PricePageReferralCardDataType;
}

function LongReferralCard({ referralCardEntry }: ReferralCardProps) {
  const t = useTranslations(FILES.PRICES);
  const { country, isUK, isSG } = useCountryStateCookies();

  const { countryOverride = [], ...cardEntry } = referralCardEntry || {
    titleText: "",
    ctaText: "",
    bodyText: ""
  };

  const overridedData = countryOverride.filter(
    (item) => item.fields.country === country
  );

  if (overridedData.length > 0) {
    cardEntry.titleText = overridedData[0].fields.titleText;
    cardEntry.ctaText = overridedData[0].fields.ctaText;
    cardEntry.bodyText = overridedData[0].fields.bodyText;
  }

  if (isUK) {
    return null;
  }

  if (isSG) {
    return null;
  }

  return (
    <div className="relative mb-[48px] hidden items-start overflow-hidden rounded-2xl bg-[#FF6A02] p-[36px] [@media(min-width:710px)]:flex [@media(min-width:904px)]:hidden">
      <div className="flex-1 text-white">
        <Heading
          size="md"
          className="mb-[8px] max-w-[200px] !text-[28px] leading-[32px] font-medium tracking-[-0.5px]"
        >
          {cardEntry.titleText || t("referFriendCardTitle")}
        </Heading>
        <Body size="sm" className="leading-[20px] font-semibold">
          {cardEntry.bodyText || t("referFriendCardBody")}
        </Body>
        <div className="mt-[16px] flex gap-2">
          <Button
            href="https://exchange.gemini.com/register"
            className="!bg-white !py-[10px] !text-black"
            size="sm"
            target="_blank"
          >
            <Body size="sm" className="leading-[16px] font-semibold">
              {cardEntry.ctaText}
            </Body>
          </Button>
          <Button
            role="link"
            target="_blank"
            size="sm"
            href="https://www.gemini.com/referral-club"
            className="!border-1 border-1 !border-white !bg-[#FF6A02] !py-[10px] text-white"
          >
            <Body size="sm" className="leading-[16px] font-semibold text-white">
              {t("learnMore")}
            </Body>
          </Button>
        </div>
      </div>
      <div className="relative -mb-10 flex flex-1 justify-end self-end">
        <img
          src={buildContentfulImageUrl(
            "3byOSfyWkpsbj9NUpLMYgs/5ca71703e6d4f833e42a928139398fc9/Black.png"
          )}
          alt="Referral card image"
          className="max-w-full self-end object-contain"
        />
      </div>
    </div>
  );
}

export default LongReferralCard;
